export const selectActiveBot = (store: any) => store.activeBot
export const selectActiveBotId = (store: any): number => store.activeBot.id
